import { capitalize } from "neetocist";
import useTimer from "neetocommons/react-utils/useTimer";
import { timeFormat } from "neetocommons/utils/datetime";
import { Tooltip, Typography } from "neetoui";
import PropTypes from "prop-types";
import { fromPairs, keys } from "ramda";

const DateFormat = fromPairs(
  keys(timeFormat).map(key => [
    capitalize(key),
    ({
      date,
      timerInterval = 60,
      tooltipProps = {},
      typographyProps = {},
      tooltipDateFormat = "extended",
    }) => {
      useTimer(timerInterval);

      return (
        <Tooltip
          interactive
          appendTo={() => document.body}
          content={timeFormat[tooltipDateFormat](date)}
          disabled={key === tooltipDateFormat}
          position="top"
          touch={["hold", 500]}
          {...tooltipProps}
        >
          <Typography component="span" style="body2" {...typographyProps}>
            {timeFormat[key](date)}
          </Typography>
        </Tooltip>
      );
    },
  ])
);

DateFormat.propTypes = {
  /**
   * The date object to be formatted.
   */
  date: PropTypes.instanceOf(Date),
  /**
   * This prop will be used to re-render the component in every `timerInterval` seconds to show updated relative time.
   */
  timerInterval: PropTypes.number,
  /**
   * This prop will accept a string to set the format corresponding to
   * [dateFormat](https://github.com/bigbinary/neeto-commons-frontend/blob/main/docs/utils/dateFormat.md)
   * options from `neeto-commons-frontend`.
   */
  tooltipDateFormat: PropTypes.string,
  /**
   * This prop will be forwarded to the neetoui Tooltip component. Default position is "top".
   */
  tooltipProps: PropTypes.object,
  /**
   * This prop will be forwarded to the neetoui Typography component.
   */
  typographyProps: PropTypes.object,
};

export default DateFormat;
